import axios from 'axios'

export const createApi = (visitData) => {
  return axios.post(
    `${process.env.REACT_APP_BE_URL}/visits`,
    visitData
  )
}
